/**
 * Controla apenas a exibição do botão "Inscrever" no dashboard (/painel).
 * Não afeta a rota /inscrever nem o envio do formulário público.
 */
export const dashboardInscricaoAberta = false;

export const MENSAGEM_INSCRICOES_FINALIZADAS = 'Inscrições finalizadas.';
